import { Node } from "../../display/Node";
import { Shader3D } from "../../RenderEngine/RenderShader/Shader3D";
import { ILaya } from "../../../ILaya";
import { LayaGL } from "../../layagl/LayaGL";
import { Laya3DRender } from "../RenderObjs/Laya3DRender";
import { ShaderDataType } from "../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { Event } from "../../events/Event";
import { StatElement } from "../../layagl/StatisticsContext";
export var StaticFlag;
(function (StaticFlag) {
    StaticFlag[StaticFlag["Normal"] = 1] = "Normal";
    StaticFlag[StaticFlag["StaticBatch"] = 2] = "StaticBatch";
})(StaticFlag || (StaticFlag = {}));
export class Sprite3D extends Node {
    static __init__() {
        Sprite3D.WORLDMATRIX = Shader3D.propertyNameToID("u_WorldMat");
        Sprite3D.WORLDINVERTFRONT = Shader3D.propertyNameToID("u_WorldInvertFront");
        Sprite3D.sprite3DCommandUniformMap = LayaGL.renderDeviceFactory.createGlobalUniformMap("Sprite3D");
        Sprite3D.sprite3DCommandUniformMap.addShaderUniform(Sprite3D.WORLDMATRIX, "u_WorldMat", ShaderDataType.Matrix4x4);
        Sprite3D.sprite3DCommandUniformMap.addShaderUniform(Sprite3D.WORLDINVERTFRONT, "u_WorldInvertFront", ShaderDataType.Vector4);
    }
    static instantiate(original, parent = null, worldPositionStays = true, position = null, rotation = null) {
        var destSprite3D = original.clone();
        (parent) && (parent.addChild(destSprite3D));
        var transform = destSprite3D.transform;
        if (worldPositionStays) {
            var worldMatrix = transform.worldMatrix;
            original.transform.worldMatrix.cloneTo(worldMatrix);
            transform.worldMatrix = worldMatrix;
        }
        else {
            (position) && (transform.position = position);
            (rotation) && (transform.rotation = rotation);
        }
        return destSprite3D;
    }
    static load(url, complete) {
        ILaya.loader.load(url).then((res) => {
            complete && complete.runWith([res === null || res === void 0 ? void 0 : res.create()]);
        });
    }
    get id() {
        return this._id;
    }
    get layer() {
        return this._layer;
    }
    set layer(value) {
        if (this._layer !== value) {
            if (value >= 0 && value <= 30) {
                this._layer = value;
                this.event(Event.LAYER_CHANGE, value);
            }
            else {
                throw new Error("Layer value must be 0-30.");
            }
        }
    }
    get isStatic() {
        return !!(this._isStatic >> 1 | 0x0);
    }
    set isStatic(value) {
        this._isStatic = value ? StaticFlag.StaticBatch : StaticFlag.Normal;
        this.event(Event.STATIC_MASK, this._isStatic);
    }
    get transform() {
        return this._transform;
    }
    get scene() {
        return this._scene;
    }
    constructor(name, isStatic) {
        super();
        this._isRenderNode = 0;
        this._nodeType = 1;
        this._id = ++_uniqueIDCounter;
        this._transform = Laya3DRender.Render3DModuleDataFactory.createTransform(this);
        this._isStatic = isStatic ? StaticFlag.StaticBatch : StaticFlag.Normal;
        this.layer = 0;
        this.name = name ? name : "New Sprite3D";
    }
    _onActive() {
        super._onActive();
        LayaGL.statAgent.recordCountData(StatElement.C_Sprite3DCount, 1);
    }
    _onInActive() {
        super._onInActive();
        LayaGL.statAgent.recordCountData(StatElement.C_Sprite3DCount, -1);
    }
    _onAdded() {
        if (this._parent instanceof Sprite3D) {
            var parent3D = this._parent;
            this.transform._setParent(parent3D.transform);
        }
        else
            this.transform._onWorldTransform();
        super._onAdded();
    }
    _onRemoved() {
        super._onRemoved();
        if (this._parent instanceof Sprite3D)
            this.transform._setParent(null);
    }
    onStartListeningToType(type) {
        super.onStartListeningToType(type);
        if (type.startsWith("collision") || type.startsWith("trigger"))
            this.event(Event.UPDATE_PHY_EVENT_FILTER);
    }
    _cloneTo(destObject, srcRoot, dstRoot) {
        if (this._destroyed)
            throw new Error("Sprite3D: Can't be cloned if the Sprite3D has destroyed.");
        var trans = this._transform;
        var destTrans = destObject._transform;
        destObject.name = this.name;
        destObject.tag = this.tag;
        destObject._destroyed = this._destroyed;
        destObject.active = this.active;
        destTrans.localPosition = trans.localPosition;
        destTrans.localRotation = trans.localRotation;
        destTrans.localScale = trans.localScale;
        destObject._isStatic = this._isStatic;
        destObject.layer = this.layer;
        super._cloneTo(destObject, srcRoot, dstRoot);
    }
    static _createSprite3DInstance(scrSprite) {
        let node = new (Object.getPrototypeOf(scrSprite).constructor)();
        let children = scrSprite._children;
        for (let i = 0, n = children.length; i < n; i++) {
            let child = Sprite3D._createSprite3DInstance(children[i]);
            node.addChild(child);
        }
        return node;
    }
    static _parseSprite3DInstance(srcRoot, dstRoot, scrSprite, dstSprite) {
        let srcChildren = scrSprite._children;
        let dstChildren = dstSprite._children;
        for (let i = 0, n = srcChildren.length; i < n; i++)
            Sprite3D._parseSprite3DInstance(srcRoot, dstRoot, srcChildren[i], dstChildren[i]);
        scrSprite._cloneTo(dstSprite, srcRoot, dstRoot);
    }
    clone() {
        let dstSprite3D = Sprite3D._createSprite3DInstance(this);
        Sprite3D._parseSprite3DInstance(this, dstSprite3D, this, dstSprite3D);
        return dstSprite3D;
    }
    destroy(destroyChild = true) {
        if (this._destroyed)
            return;
        super.destroy(destroyChild);
        this._transform = null;
    }
}
var _uniqueIDCounter = 0;
